<template>
  <Modal
    ref="selectDescriptionTempModalRef"
    :showIcon="false"
    :clickToClose="true"
    class="add-single-variant-modal"
    :modalStyle="{ width: '896px', height: '582px' }"
    @modalClosed="onModalClosed"
  >
    <template v-slot:body style="gap: 24px;">
      <div class="header">
        <p class="title">Açıklama Şablonu Seç</p>
      </div>
      
      <div class="input-area">
        <div class="dropdown-container">
          <DropdownSelectable
              :dropItems="templates"
              label="Şablon Seç"
              notFoundText="Şablon bulunamadı."
              :singleItemTextLength="showApprovalStatusDropdown ? 50 : 80"
              customInputLabel="Yeni Değer Ekle"
              isRadioGroup
              @selectedRadioItem="onTemplateSelect"
            />
        </div>
        <div class="content-body">
            <HtmlDisplay class="template-content" v-if="selectedTemplate && selectedTemplate.description" :content="selectedTemplate.description" />
            <div v-else class="content-item">
              <img src="@/assets/images/empty-folder.svg" alt="">
              <p>İçeriği görebilmek için bir şablon seçin.</p>
            </div>
        </div>
      </div>

      <div class="button-container">
        <AppButton @click="closeModal" style="width: 100%;" secondary lg title="Vazgeç"></AppButton>
        <AppButton @click="handleUseTemplate" style="width: 100%;" :disabled="!selectedTemplate" primary lg title="Bu Şablonu Kullan"></AppButton>
      </div>
      
    </template>
  </Modal>
</template>

<script setup>
import { ref, defineExpose, defineEmits } from "vue";
import { Modal, AppButton, DropdownSelectable } from "@n11/so-ui-components";
import HtmlDisplay from "./HtmlDisplay.vue";

const props = defineProps({
  templates: {
    type: Array,
    required: true
  },
});
const emit = defineEmits(['templateApplied']);

const selectDescriptionTempModalRef = ref(null);
const selectedTemplate = ref(null);

const openModal = async () => {
  selectDescriptionTempModalRef.value?.openModal();
};

const closeModal = () => {
  selectDescriptionTempModalRef.value?.hiddenModal();
  selectedTemplate.value = null;
};

const onModalClosed = () => {
  selectedTemplate.value = null;
};

const onTemplateSelect = (selectedItem) => {
  selectedTemplate.value = selectedItem || null;
};

const handleUseTemplate = () => {
  if (selectedTemplate.value && typeof selectedTemplate.value.description === 'string') {
    emit('templateApplied', selectedTemplate.value);
  }
  closeModal();
};

defineExpose({
  openModal,
});

</script>

<style lang="scss" scoped>
@import '@/assets/styles/variables.scss';
@import '@/assets/styles/utilities.scss';

.header {
  display: flex;
  flex-direction: column;
  gap: 8px;
  align-items: flex-start;
}

.add-single-variant-modal.modal-mask :deep(.modal-wrapper .modal-container) {
  position: relative;
  padding: 20px;
  .modal-body {
    padding: 0px;
    height: 100%;
    overflow-y: visible;

    .content {
      gap: 24px;
    }
  }

  .modal-header.hasCloseIcon {
    position: absolute;
    top: 7px;
    right: 4px;
  }
}

.title {
  color: $colorN80;
  font-size: 20px;
  font-weight: 700;
  line-height: 26px;
  letter-spacing: -0.2px;
}

.text {
  color: $colorN80;
  font-size: 14px;
  font-weight: 400;
  line-height: 18px;
  letter-spacing: -0.05px;
}

.input-area {
    width: 100%;
    display: grid;
    grid-template-columns: repeat(1, 1fr);
    gap: 20px;

    .input-with-title {
      gap: 10px;
      font-size: 14px;
      line-height: 18px;
      font-weight: 600;
      color: $colorN80;
      text-align: left;
    }
  }
.dropdown-container {
  max-width: 552px;

}

.content-body {
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 352px;
  background-color: $colorN10;
}

.content-item {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 24px 16px;
  gap: 16px;
  width: 100%;
  height: 100%;
  color: $colorN80;
  font-size: 14px;
  font-weight: 600;
  line-height: 18px;
  letter-spacing: -0.05px;
}
.template-content {
  padding: 12px;
  width: 100%;
  height: 100%;
  color: #808080;
  font-size: 14px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  border-radius: 6px;
  border: 0.5px solid var($colorD30, #B3BBCB);
  background: var(--Neutral---Background-N00, #FFF);
  overflow-y: scroll;
}

.button-container {
  display: flex;
  bottom: 20px;
  gap: 16px;
  width: 100%;
}
</style>
